(function(angular, module) {var SectionController, sectionDirective;

SectionController = (function() {

  /* @ngInject */
  function SectionController($scope, moment) {
    this.scope = $scope;
    this.quarterStart = moment().startOf('quarter');
  }

  Object.defineProperties(SectionController.prototype, {
    name: {
      get: function() {
        return this.config.name;
      }
    },
    toggleData: {
      get: function() {
        return this.grantReport.section_toggles[this.name];
      }
    },
    sectionData: {
      get: function() {
        return this.grantReport[this.name];
      }
    },
    noChangeVerified: {
      get: function() {
        var ref, ref1;
        return (ref = this.scope.dybForm) != null ? (ref1 = ref.verify) != null ? ref1.activeData : void 0 : void 0;
      }
    },
    showItems: {
      get: function() {
        var ref, ref1;
        return this.config.toggle !== "user" || ((ref = this.scope.dybForm) != null ? (ref1 = ref.toggle) != null ? ref1.activeData : void 0 : void 0);
      }
    }
  });

  SectionController.prototype.noChanges = function() {
    var i, item, len, ref, results;
    ref = this.config.items;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      item = ref[i];
      if (this.actualIssue(item)) {
        results.push(item);
      }
    }
    return results;
  };

  SectionController.prototype.actualIssue = function(item) {
    var actual, ref;
    if (item.type !== 'metric') {
      return false;
    }
    actual = (ref = this.scope.dybForm[item.name]) != null ? ref.actual : void 0;
    if (actual == null) {
      return false;
    }
    return !actual.hasChanged && this.sectionData[item.name].last_verified.isBefore(this.quarterStart, 'day');
  };

  SectionController.prototype.save = function(data) {
    return this.saveCallback({
      data: data
    });
  };

  return SectionController;

})();

sectionDirective = function() {
  'ngInject';
  return {
    restrict: 'A',
    templateUrl: 'programs/initiatives/amcGrantReportSection',
    controller: SectionController,
    controllerAs: 'ctrl',
    scope: {},
    bindToController: {
      config: '=amcGrantReportSection',
      grantReport: '=',
      saveCallback: '&save',
      afterSave: '&',
      editable: '='
    }
  };
};

module.directive('amcGrantReportSection', sectionDirective);
})(angular, angular.module("amcGrantReport"));